import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { stats } from '@/mocks/comics';

export default function About() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '韩漫网站',
        url: typeof window !== 'undefined' ? window.location.origin : '',
        description: '韩漫网站是你的专属免费韩漫平台，支持韩漫在线阅读与无删减韩国漫画下拉式浏览。',
        foundingDate: '2020',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: 'contact@hanman.com',
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 韩漫网站',
        description: '了解韩漫网站品牌故事、平台优势和联系方式。专注免费韩漫在线阅读，提供无删减韩国漫画下拉式浏览体验。',
        url: typeof window !== 'undefined' ? window.location.href : '',
        isPartOf: {
          '@type': 'WebSite',
          name: '韩漫网站',
          url: typeof window !== 'undefined' ? window.location.origin : '',
        },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: typeof window !== 'undefined' ? window.location.origin + '/' : '/' },
            { '@type': 'ListItem', position: 2, name: '关于我们' },
          ],
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />

      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="bg-background-50 border-b border-background-200">
          <div className="px-4 md:px-6 max-w-6xl mx-auto py-4">
            <nav className="flex items-center gap-2 text-sm text-foreground-500" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-xs w-4 h-4 flex items-center justify-center"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Hero */}
        <section className="relative py-20 md:py-28 bg-background-100 overflow-hidden">
          <div className="absolute inset-0 opacity-[0.03]">
            <div className="absolute top-10 left-10 text-9xl font-heading font-bold text-foreground-950 select-none">韩漫</div>
            <div className="absolute bottom-10 right-10 text-9xl font-heading font-bold text-foreground-950 select-none">漫</div>
          </div>
          <div className="px-4 md:px-6 max-w-3xl mx-auto text-center relative z-10">
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">关于韩漫网站</h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
              韩漫网站是专注于韩国漫画在线免费阅读的中文平台。我们致力于为广大韩漫爱好者提供最全面、最高质量的韩漫阅读体验。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6 max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">品牌故事</h2>
            <div className="prose max-w-none">
              <p className="text-foreground-600 leading-relaxed mb-6">
                韩漫网站诞生于2020年，由一群热爱韩国漫画的资深读者创建。创始人曾在韩国留学多年，深切体会到韩国漫画独特的艺术魅力和叙事风格。回国后发现国内缺乏一个专注、优质的韩漫阅读平台，于是决定亲手打造韩漫网站。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-6">
                从最初只有几百部作品的简陋页面，发展到现在拥有超过<span className="text-primary-500 font-semibold">{stats.totalComics}</span>部韩漫资源的大型阅读平台，我们走过了不平凡的六年。每一步成长，都离不开广大读者的支持与信任。
              </p>
              <p className="text-foreground-600 leading-relaxed">
                我们的愿景是成为中国乃至全球最受欢迎的韩漫在线阅读平台。无论你是韩漫老粉还是刚刚入坑的新人，在韩漫网站都能找到属于自己的精彩故事。我们始终相信，好的漫画能够跨越语言和文化的障碍，触动每一个人的心灵。
              </p>
            </div>
          </div>
        </section>

        {/* Platform Advantages */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-6xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-12">平台优势</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-2xl p-8 border border-background-200/60">
                <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-5">
                  <i className="ri-book-3-line text-2xl text-primary-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">海量正版韩漫</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  收录超过{stats.totalComics}部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑、BL、GL等丰富题材。从经典名作到热门新番，你想要的韩漫这里都有。
                </p>
              </div>
              <div className="bg-background-50 rounded-2xl p-8 border border-background-200/60">
                <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mb-5">
                  <i className="ri-file-list-3-line text-2xl text-accent-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">下拉式流畅阅读</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  专为移动端优化的下拉式浏览模式，滑动即可翻页，无需频繁点击。完美适配手机、平板和电脑，随时随地享受沉浸式韩漫阅读体验。
                </p>
              </div>
              <div className="bg-background-50 rounded-2xl p-8 border border-background-200/60">
                <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mb-5">
                  <i className="ri-shield-star-line text-2xl text-secondary-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">无删减完整版</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有韩漫内容均为无删减完整版本，保留原作的全部剧情和画面细节。原汁原味呈现韩国漫画的精彩内容与精美画风，绝不妥协阅读品质。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation & Stats */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6 max-w-6xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-12">信誉与数据</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
              <div className="text-center p-6 bg-background-100 rounded-2xl">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-2">{stats.totalComics}</div>
                <div className="text-sm text-foreground-600">海量韩漫资源</div>
              </div>
              <div className="text-center p-6 bg-background-100 rounded-2xl">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-2">{stats.totalChapters}</div>
                <div className="text-sm text-foreground-600">精彩章节内容</div>
              </div>
              <div className="text-center p-6 bg-background-100 rounded-2xl">
                <div className="text-3xl md:text-4xl font-bold text-accent-500 mb-2">{stats.dailyReaders}</div>
                <div className="text-sm text-foreground-600">每日活跃读者</div>
              </div>
              <div className="text-center p-6 bg-background-100 rounded-2xl">
                <div className="text-3xl md:text-4xl font-bold text-accent-500 mb-2">{stats.satisfaction}</div>
                <div className="text-sm text-foreground-600">读者满意度</div>
              </div>
            </div>

            {/* User Reviews */}
            <h3 className="font-heading text-xl font-bold text-foreground-900 text-center mb-8">读者评价</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { name: '小王', comment: '这个网站太好用了！资源超全，什么类型的韩漫都能找到，而且更新速度很快，追更党的福音。', rating: 5 },
                { name: '花开花落', comment: '下拉式阅读体验真的绝了，躺着刷漫画太舒服了。漫画画质也很清晰，强烈推荐！', rating: 5 },
                { name: '漫画控', comment: '用了很多漫画网站，这个是我最喜欢的。界面干净没有广告骚扰，分类也很清楚，找漫画特别方便。', rating: 5 },
              ].map((review, i) => (
                <div key={i} className="bg-background-100 rounded-2xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-amber-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">"{review.comment}"</p>
                  <p className="text-xs text-foreground-500">—— {review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">联系我们</h2>
            <p className="text-foreground-600 text-center mb-10">有任何问题或建议？欢迎随时联系我们</p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
              <div className="bg-background-50 rounded-2xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">邮箱</h4>
                <p className="text-xs text-foreground-500">contact@hanman.com</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">微信</h4>
                <p className="text-xs text-foreground-500">hanman_official</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-weibo-line text-xl text-secondary-500 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">微博</h4>
                <p className="text-xs text-foreground-500">@韩漫网站官方</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}